export const COMMESSA_SELEZIONATA = 'COMMESSA_SELEZIONATA';